module.exports = __webpack_public_path__ + "static/img/regCode-0.14d998f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/regCode-0.png
// module id = PgPB
// module chunks = 1